<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Organic Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first">
            <sub-product tit="Organic Line" file="organic">
                Organic cotton, Better cotton, Bamboo, Recycled poly, Sorona , Eco Vero, etc. All we must care about the Environment. Accordingly, we are working with factories with certification. Join Meitex to protect the environment!
            </sub-product>
        </sub-section>

        <sub-section class="page-section--last">
            <v-container>
                <v-row class="py-30 py-md-60 px-30" style="border: 1px solid #e6e6e6">
                    <v-card style="margin: 0 auto;" flat>
                        <v-img src="/images/sub/product/organic/main_img.png" style="max-width: 600px;"></v-img>
                    </v-card>
                </v-row>
            </v-container>
            <!-- <v-img src="/images/sub/product/organic/organic-img2.jpg"></v-img> -->
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
